export const OrdersColumns = [
    {
        name: 'Номер накладной',
        key: 'invoice_number',
    },
    {
        name: 'Дата создания',
        key: 'created_at',
    },
    {
        name: 'Тип доставки',
        key: 'shipment_type',
    },
    {
        name: 'Направление',
        key: 'direction',
    },
    {
        name: 'Физ. вес',
        key: 'weight'
    },
    {
        name: 'Наличка',
        key: 'cash_sum',
    },
    {
        name: 'Примечание к отправке',
        key: 'annotation',
    },
    {
        name: 'Коробка',
        key: 'size_type',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Дата забора',
        key: 'take_date',
    },
]
